import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IRegistrationInitState, SendToEnum } from "../../types/types";

const initialState: IRegistrationInitState = {
  phone: null,
  email: null,
  reg_token: null,
  sended_to: null,
  verify_token: null,
  sended_to_value: null,
  passport: {
    name: null,
    sur_name: null,
    patronymic: null,
  },
  _errors: [],
  _token: null,
  _s3Token: null,
  _isLoading: false,
  _isForeignPhone: false,
  _marketing_agreement: false,
};

export const registrationSlice = createSlice({
  name: "registrationSlice",
  initialState,
  reducers: {
    SetName: (state, action: PayloadAction<string | null>) => {
      state.passport.name = action.payload;
    },
    SetSurname: (state, action: PayloadAction<string | null>) => {
      state.passport.sur_name = action.payload;
    },
    SetPatronymic: (state, action: PayloadAction<string | null>) => {
      state.passport.patronymic = action.payload;
    },
    SetPassport: (
      state,
      action: PayloadAction<IRegistrationInitState["passport"]>
    ) => {
      state.passport = action.payload;
    },
    SetPhone: (state, action: PayloadAction<string | null>) => {
      state.phone = action.payload;
    },
    SetEmail: (state, action: PayloadAction<string | null>) => {
      state.email = action.payload;
    },
    SetIsLoading: (state, action: PayloadAction<boolean>) => {
      state._isLoading = action.payload;
    },
    SetErrors: (state, action: PayloadAction<string[]>) => {
      state._errors = action.payload;
    },
    AddError: (state, action: PayloadAction<string>) => {
      state._errors.push(action.payload);
    },
    SetReqToken: (state, action: PayloadAction<string | null>) => {
      state.reg_token = action.payload;
    },
    SetIsForeignPhone: (state, action: PayloadAction<boolean>) => {
      state._isForeignPhone = action.payload;
    },
    SetSendedTo: (state, action: PayloadAction<SendToEnum | null>) => {
      state.sended_to = action.payload;
    },
    SetSendedToValue: (state, action: PayloadAction<string | null>) => {
      state.sended_to_value = action.payload;
    },
    SetVerifyToken: (state, action: PayloadAction<string | null>) => {
      state.verify_token = action.payload;
    },
    SetToken: (state, action: PayloadAction<string | null>) => {
      state._token = action.payload;
    },
    SetS3Token: (state, action: PayloadAction<string | null>) => {
      state._s3Token = action.payload;
    },
    SetMarketingAgreement: (state, action: PayloadAction<boolean>) => {
      state._marketing_agreement = action.payload;
    },
  },
});

export const {
  AddError,
  SetName,
  SetPhone,
  SetEmail,
  SetToken,
  SetErrors,
  SetSurname,
  SetS3Token,
  SetPassport,
  SetReqToken,
  SetSendedTo,
  SetIsLoading,
  SetPatronymic,
  SetVerifyToken,
  SetSendedToValue,
  SetIsForeignPhone,
  SetMarketingAgreement,
} = registrationSlice.actions;

export default registrationSlice.reducer;
